module.exports = __webpack_public_path__ + "static/logo_swps-09d1891b44965ee70d53cc23e0a44aa5.svg";